import {connect} from 'react-redux';
import axios from 'axios';
import {Alert, Platform} from "react-native"

import LoginEnterUsernameSatiaScreen from '../../../../satia/login/enterUsername/LoginEnterUsernameSatiaScreen';
import {
    serviceActionAccount,
    serviceActionSetState,
    serviceActionSetToken, serviceActionSetTypeLogin,
    serviceActionSetUser
} from "../../../splash/action/ActionSplashSatiaScreen";
import * as NavigationService from "../../../../../redux/NavigationService";
import store from "../../../../../redux/store";
import i18n from "../../../../../I18n/i18n";
import {typeExport} from "../../../../../redux/store/type";
import {Tools} from "../../../../../tools/Tools";
import HMAlert from "../../../../../customviews/HMAlert";
import {AsyngStorageClass} from "../../../../../tools/AsyngStorageClass";

const mapStateToProps = (state) => ({
    results: state.reducerLoginEnterUsernameSatiaScreen.results,
    NoInternetDialog: state.reducerLoginEnterUsernameSatiaScreen.NoInternetDialog,
    isLoading: state.reducerLoginEnterUsernameSatiaScreen.isLoading,


    ConnectionType: state.reducerSplashSatiaScreen.ConnectionType,
    wifiIsEnabled: state.reducerSplashSatiaScreen.wifiIsEnabled,
    wifiConnectionStatus: state.reducerSplashSatiaScreen.wifiConnectionStatus,
    ConnectionInternetHotspot: state.reducerSplashSatiaScreen.ConnectionInternetHotspot,

    DataSplashScreen: state.reducerSplashSatiaScreen,
});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, stateData, funcRetryCode) => dispatch(callWebservice(getState, url, params, type, typeConnection, stateData, funcRetryCode)),
    callServiceSetState: (data) => dispatch(serviceActionSetState(data)),
    callServiceError: (data) => dispatch(serviceActionError(data)),
    callServiceRefresh: () => dispatch(serviceActionRefresh()),

})

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, stateData, funcRetryCode) => {
    // let checkTypeLogin = getState.route.params && getState.route.params.type == "forgot_my_password";
    dispatch(serviceActionPending());

    const formData = new FormData();
    //   formData.append('_operation', params._operation);
    //  formData.append('mode', params.mode);
    // formData.append('forgotmode', params.forgotmode);

    formData.append('password', params.password);
    formData.append('username', params.username);
    //khalili
    // formData.append('token', "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC8xOTIuMTY4LjE2OC4yMjM6ODAwMFwvb3BlcmF0b3JcL2xvZ2luIiwiaWF0IjoxNjQyNTAyNDEzLCJleHAiOjM3NjQyNTAyNDEzLCJuYmYiOjE2NDI1MDI0MTMsImp0aSI6ImhuQkpPR2o0bnU4Wk9qUGMiLCJzdWIiOjQ1NjU5LCJwcnYiOiI4N2UwYWYxZWY5ZmQxNTgxMmZkZWM5NzE1M2ExNGUwYjA0NzU0NmFhIn0.813S5KCttS-jdb2q_aPlyNfTaA48ib4htMRxomya8cY");

    //arak
    //  formData.append('token', "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC8xOTIuMTY4LjE2OC4yMjM6ODAwMFwvb3BlcmF0b3JcL2xvZ2luIiwiaWF0IjoxNjQyNjY4NzM3LCJleHAiOjM3NjQyNjY4NzM3LCJuYmYiOjE2NDI2Njg3MzcsImp0aSI6IjZIUXpOUnQ5dkZRSTVseUkiLCJzdWIiOjI3NDczLCJwcnYiOiI4N2UwYWYxZWY5ZmQxNTgxMmZkZWM5NzE1M2ExNGUwYjA0NzU0NmFhIn0.9LJEZU9qqHRr3XMVJyC1fdF111-GcE2TsNjLvWlpk4U");

    if (params.HashCode)
        formData.append('HashCode', params.HashCode + "");

    Tools.DeviceInfo(formData);


    //  let _abis=null;
    // DeviceInfo.supportedAbis().then(abis => {
    //
    //     _abis=abis&&abis.length>0?abis[0];
    //     // [ "arm64 v8", "Intel x86-64h Haswell", "arm64-v8a", "armeabi-v7a", "armeabi" ]
    // });
    // formData.append('DeviceInfo',  JSON.stringify({name:"aaa",abis:_abis,}));

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
            // 'Access-Control-Allow-Origin': '*',
            //  withCredentials: true
        }
    };

    /*  axios(
          {
              //  url: baseUrl + url + params,
              url: url ,
              method: typeConnection,
          //    params: params,
              data:params,
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              },

          }
      )*/

    axios({
        method: 'post',
        url: url,
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
        timeout: typeExport._TIMEOUT,

    })
    // axios.post(url, formData, config)
        .then(async response => {

            switch (type) {

                case typeExport.TypegetDataLoginEnterUsernameSatiaScreen:

                    if (response.data.status) {
                        let user = response.data.user

                        if (typeExport._NameApp == "Satia") {
                            let user = response.data.user;

                            global.CodeMobile = params.code;
                            dispatch(serviceActionSuccess(response.data));


                            /**/
                            await AsyngStorageClass.setAsyng(typeExport._USER, response.data.result);
                            await AsyngStorageClass.setToken(user.token ? user.token : user.session);

                            //  dispatch(SetResultSuccessSplashSatia(response.data));

                            dispatch(serviceActionSetUser(user));
                            dispatch(serviceActionSetToken(user.token ? user.token : user.session));
                            /**/

                            if (user.customers && user.customers.length > 1) {
                                //   alert("ok")

                                /*  NavigationService.resetTo("ListAccountSatiaScreen", {

                                      item: response.data,
                                  });*/
                            }
                            else {
                                let account = user.customers[0];
                                await AsyngStorageClass.setAsyng("Account", account);
                                store.dispatch(serviceActionAccount(account, 0));

                                /*   try {
                                       NavigationService.resetTo('SplashSatiaScreen')

                                   } catch (e) {
                                       NavigationService.navigatereset('SplashSatiaScreen')

                                   }*/

                            }
                        }
                        else {
                            dispatch(serviceActionSuccess(response.data));
                            // NavigationService.navigateParams('SplashScreen',);
                            if (!funcRetryCode) {
                                dispatch(serviceActionSetTypeLogin("operator"));
                                /**/
                                await AsyngStorageClass.setAsyng(typeExport._USER, user);
                                await AsyngStorageClass.setToken(user.token ? user.token : user.session)

                                //  dispatch(SetResultSuccessSplashSatia(response.data));

                                dispatch(serviceActionSetUser(user))
                                dispatch(serviceActionSetToken(user.token ? user.token : user.session))


                                /**/
                            }

                            // NavigationService.navigateParams("EnterCodeSatiaScreen", {
                            //     //  type: funcRetryCode || global.funcRetryCodeLogin ? "Login_with_activation_code" : (getState.route.params && getState.route.params.type ? getState.route.params.type : ""),
                            //     type: "",
                            //
                            //     mobile: params.mobile,
                            //     result_extra: response.data,
                            // });
                            else {
                                funcRetryCode()
                            }
                        }

                    } else {
                        dispatch(serviceActionRefresh())
                        HMAlert(
                            i18n.t('constant.message'),
                            response.data.message,
                            [
                                {
                                    text: i18n.t('constant.ok'),
                                    onPress: () => {


                                    }
                                },

                            ],
                            {cancelable: true}
                        )
                        //alert(response.data.error.message)
                    }

                    break;


                default:
            }
        }).catch((e) => {
        dispatch(serviceActionError(e))
    })
}


export const callWebservice = (getState, url, params, type, typeConnection, stateData, funcRetryCode) => {

    return dispatch => {


        // NetInfo.isConnected.fetch().then(isConnected => {
        //     if (isConnected) {
        //         getDataDisatch(dispatch, getState, url, params, type, typeConnection,stateData);
        //     }
        //     else {
        //         dispatch(serviceActionError("No Internet Connection"));
        //
        //     }
        // });

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, stateData, funcRetryCode);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection"));
        //
        //         }
        //     }
        // )


        if (store.getState().reducerSplashSatiaScreen.Connection) {
            getDataDisatch(dispatch, getState, url, params, type, typeConnection, stateData, funcRetryCode);
        } else {
            dispatch(serviceActionError("No Internet Connection"));

        }


    }
}


export const serviceActionPending = () => ({
    type: typeExport.LoginEnterUsernameSatiaScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    results: null

})

export const serviceActionError = (error) => ({
    type: typeExport.LoginEnterUsernameSatiaScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    isLoading: false,
    error: error
})

export const serviceActionSuccess = (data) => ({
    type: typeExport.LoginEnterUsernameSatiaScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    isLoading: false,
    results: data,


})

export const serviceActionRefresh = () => ({
    type: typeExport.LoginEnterUsernameSatiaScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    isLoading: false,
    results: null
})
export default connect(mapStateToProps, mapDispatchToProps)(LoginEnterUsernameSatiaScreen);
